import { InvestorDashboard } from '@/features/dashboard';

export default function InvestorDashboardPage() {
  return <InvestorDashboard />;
}
